import { IPolicyFilterLovs } from '.';
import { FormInputTypes } from '@components/_old/dynamicForm';
import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';

export const getHeaders: (
  type: 'single' | 'group'
) => Record<string, EnhancedTableHeader> = (type) => ({
  Production_Policy_PolicyNumber: {
    name: 'production_Policy_PolicyNumber',
    title: 'Policy Number',
    type: EnhancedTableHeaderType.Link,
    urlTemplate:
      type === 'single'
        ? '/production/policies/{id}'
        : '/production/group-policies/{id}',
    openUrlInNewTab: false,
  },
  Production_Policy_PolicyName: {
    name: 'production_Policy_PolicyName',
    title: 'Name',
    type: EnhancedTableHeaderType.Link,
    urlTemplate:
      type === 'single'
        ? '/production/policies/{id}'
        : '/production/group-policies/{id}',
    openUrlInNewTab: false,
  },
  Line_ExternalCode: {
    name: 'line_ExternalCode',
    title: 'Line',
    type: EnhancedTableHeaderType.Text,
  },
  subline_ExternalCode: {
    name: 'subline_Name',
    title: 'Subline',
    type: EnhancedTableHeaderType.Text,
  },
  plan_ExternalCode: {
    name: 'plan_Name',
    title: 'Plan',
    type: EnhancedTableHeaderType.Text,
  },
  Production_Insured_FullName: {
    name: 'policyPerson_FullName',
    title: 'Insured',
    type: EnhancedTableHeaderType.Text,
  },
  Production_Policy_PolicyIssueDate: {
    name: 'production_Policy_PolicyIssueDate',
    title: 'Issue Date',
    type: EnhancedTableHeaderType.Date,
  },
  Production_Policy_PolicyEffectiveDate: {
    name: 'production_Policy_PolicyEffectiveDate',
    title: 'Effective Date',
    type: EnhancedTableHeaderType.Date,
  },
  Production_Policy_Status: {
    name: 'production_Policy_Status',
    title: 'Status',
    type: EnhancedTableHeaderType.Text,
  },
  Production_Policy_StatusReason: {
    name: 'production_Policy_StatusReason',
    title: 'Status Reason',
    type: EnhancedTableHeaderType.Text,
  },
});

export function filterSectionsContent(
  lovs: IPolicyFilterLovs,
  filterValues: IAbstractRecord
): IListingFilterWidgetSection[] {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: 'Filters',
      inputs: {
        line: {
          name: 'line',
          title: 'Line',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.line || [],
          placeholder: 'Line',
          triggerUpdate: true,
          selectOptions: { ...lovs.line },
        },
        subline: {
          name: 'subline',
          title: 'Subline',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.subline || [],
          placeholder: 'Subline',
          triggerUpdate: true,
          selectOptions: { ...lovs.subline },
        },
        plan: {
          name: 'plan',
          title: 'Plan',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.plan || [],
          placeholder: 'Plan',
          triggerUpdate: true,
          selectOptions: { ...lovs.plan },
        },
        businessPartner: {
          name: 'businessPartner',
          title: 'Business Partner',
          type: FormInputTypes.newmultiautocomplete,
          value: filterValues?.businessPartner || [],
          placeholder: 'Business Partner',
          triggerUpdate: true,
        },
        insured: {
          name: 'insured',
          title: 'Insured',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.insured || [],
          placeholder: 'Insured',
          triggerUpdate: true,
          selectOptions: { ...lovs.insured },
        },
        status: {
          name: 'status',
          title: 'Status',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.status || [],
          placeholder: 'Status',
          triggerUpdate: true,
          selectOptions: { ...lovs.status },
        },
        statusReason: {
          name: 'statusReason',
          title: 'Status Reason',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.statusReason || [],
          placeholder: 'Status Reason',
          triggerUpdate: true,
          selectOptions: { ...lovs.statusReason },
        },
        issueDate: {
          name: 'issueDate',
          title: 'Issue Date',
          type: FormInputTypes.newdaterange,
          value: filterValues.issueDate || [],
          placeholder: 'Issue Date',
          triggerUpdate: true,
        },
        effectiveDate: {
          name: 'effectiveDate',
          title: 'Effective Date',
          type: FormInputTypes.newdaterange,
          value: filterValues.effectiveDate || [],
          placeholder: 'Effective Date',
          triggerUpdate: true,
        },
      },
    },
  ];
  return newFilterSections;
}
